import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../pages/UserContext";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user } = useContext(UserContext);

  // If no user is logged in, redirect to login page
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Derive role based on user.role
  const Role = user.user_type === 1 ? "ADMIN":user.user_type === 2 ? "ADMIN" : user.user_type === 3 ? "CUSTOMER" : null;
  console.log("user_type",Role)
  // If user role doesn't match, redirect to an appropriate page
  if (requiredRole && Role !== requiredRole) {
    return <Navigate to={Role === "ADMIN" ? "/admin-dashboard" : "/home"} />;
  }

  // If user is authorized, render the children components
  return children;
};

export default ProtectedRoute;
